import ENDPOINTS from "@/lib/endpoints";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Async Thunks
export const facebookComment = createAsyncThunk(
    "extension/facebookComment",
    async () => {
        const baseUrl = process.env.NEXT_PUBLIC_API_URL;
        const response = await fetch(
            baseUrl + ENDPOINTS.GET_EXTENSION + "/fb-comment"
        );
        return response.json();
    }
);

export const googleAnalytics = createAsyncThunk(
    "extension/googleAnalytics",
    async () => {
        const baseUrl = process.env.NEXT_PUBLIC_API_URL;
        const response = await fetch(
            baseUrl + ENDPOINTS.GET_EXTENSION + "/google-analytics"
        );
        return response.json();
    }
);

export const tawkChat = createAsyncThunk("extension/tawkChat", async () => {
    const baseUrl = process.env.NEXT_PUBLIC_API_URL;
    const response = await fetch(
        baseUrl + ENDPOINTS.GET_EXTENSION + "/tawk-chat"
    );
    return response.json();
});

export const whatsapp = createAsyncThunk(
    "extension/whatsapp",
    async () => {
        const baseUrl = process.env.NEXT_PUBLIC_API_URL;
        const response = await fetch(
            baseUrl + ENDPOINTS.GET_EXTENSION + "/whatsapp"
        );
        return response.json();
    }
);

// Slice
const extensionSlice = createSlice({
    name: "extension",
    initialState: {
        facebookComment: {
            status: "idle",
            error: null,
        },
        googleAnalytics: {
            status: "idle",
            error: null,
        },
        tawkChat: {
            status: "idle",
            error: null,
        },
        whatsapp: {
            status: "idle",
            error: null,
        },
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Facebook Comment
            .addCase(facebookComment.pending, (state) => {
                state.facebookComment.status = "loading";
            })
            .addCase(facebookComment.fulfilled, (state, action) => {
                state.facebookComment.status = "succeeded";
                state.facebookComment.data = action.payload;
            })
            .addCase(facebookComment.rejected, (state, action) => {
                state.facebookComment.status = "failed";
                state.facebookComment.error = action.error.message;
            })

            // Google Analytics
            .addCase(googleAnalytics.pending, (state) => {
                state.googleAnalytics.status = "loading";
            })
            .addCase(googleAnalytics.fulfilled, (state, action) => {
                state.googleAnalytics.status = "succeeded";
                state.googleAnalytics.data = action.payload;
            })
            .addCase(googleAnalytics.rejected, (state, action) => {
                state.googleAnalytics.status = "failed";
                state.googleAnalytics.error = action.error.message;
            })

            // Tawk Chat
            .addCase(tawkChat.pending, (state) => {
                state.tawkChat.status = "loading";
            })
            .addCase(tawkChat.fulfilled, (state, action) => {
                state.tawkChat.status = "succeeded";
                state.tawkChat.data = action.payload;
            })
            .addCase(tawkChat.rejected, (state, action) => {
                state.tawkChat.status = "failed";
                state.tawkChat.error = action.error.message;
            })

            .addCase(whatsapp.pending, (state) => {
                state.whatsapp.status = "loading";
            })
            .addCase(whatsapp.fulfilled, (state, action) => {
                state.whatsapp.status = "succeeded";
                state.whatsapp.data = action.payload;
            })
            .addCase(whatsapp.rejected, (state, action) => {
                state.whatsapp.status = "failed";
                state.whatsapp.error = action.error.message;
            });
    },
});

export default extensionSlice.reducer;
